import React from "react";
import { number, string } from "prop-types";

import SlideToggle from "../../../../shared/components/SlideToggle";
import truncateAtEndOfSentence from "../../utilities/truncateAtEndOfSentence";

const defaultContentLimit = 300;
const defaultContentThreshold = 100;

const ListingDescriptionWidget = ({
  limit,
  listingDescriptionContent,
  threshold
}) => {
  if (!listingDescriptionContent) {
    return null;
  }

  const initiallyVisibleContent = truncateAtEndOfSentence(
    listingDescriptionContent,
    limit,
    threshold
  );

  return (
    <SlideToggle
      fullContent={listingDescriptionContent}
      initialContent={initiallyVisibleContent}
    />
  );
};

ListingDescriptionWidget.propTypes = {
  listingDescriptionContent: string,
  limit: number,
  threshold: number
};

ListingDescriptionWidget.defaultProps = {
  listingDescriptionContent: null,
  limit: defaultContentLimit,
  threshold: defaultContentThreshold
};

export default ListingDescriptionWidget;
